import { ICustomerRateInitialState } from "../../../types/master/customerRateInterface";
import { CustomerRateActionTypes, CustomerRateActions } from "../../actionTypes/master/customerRateActionTypes";

const initialState: ICustomerRateInitialState = {
  customerRateList: [],
  customerRateListPageCount: 0,
  customerRateData: {
    id: 0,
    customer_id: 0,
    origin_zone_id: 0,
    destination_zone_id: 0,
    service_mode: "",
    rate: 0,
    is_active: false,
    origin_zone: null,
    destination_zone: null,
    customer: null,
  },
};

export default function customerRateReducer(
  state = initialState,
  action: CustomerRateActionTypes
): ICustomerRateInitialState {
  switch (action.type) {
    case CustomerRateActions.SET_CUSTOMER_RATE_LIST:
      return {
        ...state,
        customerRateList: action.payload,
      };

    case CustomerRateActions.SET_CUSTOMER_RATE_LIST_PAGE_COUNT:
      return {
        ...state,
        customerRateListPageCount: action.payload,
      };

    case CustomerRateActions.SET_CUSTOMER_RATE_DATA_BY_ID:
      return {
        ...state,
        customerRateData: action.payload,
      };

    default:
      return state;
  }
}
